// extracted by mini-css-extract-plugin
export default {"content":"NewStories_content__B6juG","right":"NewStories_right__TRy3v"};